import axiosRaw from 'axios';

import {
  CommonResponse,
  LoginForm,
  LoginResponse,
  RegisterForm,
  RegisterResponse,
  ForgotPasswordForm,
  ForgotPasswordResponse,
  ResetPasswordForm,
  ResetPasswordResponse,
  ConfirmEmailForm,
  ConfirmEmailResponse,
  PasswordChangeForm,
  ProfileResponse,
  ProfileUpdateForm,
  AuthTokens,
  RefreshTokenForm,
} from 'src/types';
import { HOST_API } from 'src/config-global';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const login = async (data: LoginForm) => {
  const response = await axios.post<LoginResponse>(ENDPOINTS.auth.login, data);
  return response.data;
};

export const register = async (data: RegisterForm) => {
  const response = await axios.post<RegisterResponse>(ENDPOINTS.auth.register, data);
  return response.data;
};

export const forgotPassword = async (data: ForgotPasswordForm) => {
  const response = await axios.post<ForgotPasswordResponse>(ENDPOINTS.auth.forgotPassword, data);
  return response.data;
};

export const resetPassword = async (data: ResetPasswordForm) => {
  const response = await axios.post<ResetPasswordResponse>(ENDPOINTS.auth.resetPassword, data);
  return response.data;
};

export const confirmEmail = async (data: ConfirmEmailForm) => {
  const response = await axios.post<ConfirmEmailResponse>(ENDPOINTS.auth.confirmEmail, data);
  return response.data;
};

export const logout = async () => {
  const response = await axios.post(ENDPOINTS.auth.logout);
  return response.data;
};

export const updateUserProfile = async (data: ProfileUpdateForm) => {
  const response = await axios.patch<ProfileResponse>(ENDPOINTS.auth.profile, data);
  return response.data;
};

export const changePassword = async (data: PasswordChangeForm) => {
  const response = await axios.post<CommonResponse<null>>(ENDPOINTS.auth.profilePassword, data);
  return response.data;
};

export const getUserProfile = async () => {
  const response = await axios.get<ProfileResponse>(ENDPOINTS.auth.profile);
  return response.data;
};

// Uses raw axios to bypass custom interceptors (avoids circular refresh attempts)
export const refreshTokens = async (data: RefreshTokenForm) => {
  const response = await axiosRaw.post<AuthTokens>(`${HOST_API}${ENDPOINTS.auth.refresh}`, data);
  return response.data;
};
